import { render, staticRenderFns } from "./Surgeries.vue?vue&type=template&id=0213101b&scoped=true"
import script from "./Surgeries.vue?vue&type=script&lang=js"
export * from "./Surgeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0213101b",
  null
  
)

export default component.exports